import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-ai-landing',
  templateUrl: './ai-landing.component.html',
  styleUrls: ['./ai-landing.component.scss']
})
export class AiLandingComponent extends BaseComponent implements OnInit {

  schema;

  readonly apiBaseUrl = "https://buster.cheapcharts.de/v1/gptapi/";
  readonly llmsUrl = "https://www.cheapcharts.com/llms.txt";

  constructor() {
    super();
  }

  ngOnInit() {
    this.schema = {
      "@context": "https://schema.org",
      "@type": "TechArticle",
      "headline": "CheapCharts for AI Agents",
      "name": "CheapCharts GPT API documentation",
      "description": "Guidance for AI agents and LLM tools that need CheapCharts title search, deal, price, recommendation, chart, and topseller data.",
      "url": "https://www.cheapcharts.com/us/ai",
      "mainEntityOfPage": "https://www.cheapcharts.com/us/ai",
      "about": {
        "@type": "SoftwareApplication",
        "name": "CheapCharts GPT API",
        "applicationCategory": "API",
        "operatingSystem": "Web",
        "url": this.apiBaseUrl,
        "documentation": this.llmsUrl
      },
      "publisher": {
        "@type": "Organization",
        "name": "CheapCharts",
        "url": "https://www.cheapcharts.com"
      }
    };
  }

}
